import KycNotification from './KycNotification'

export default KycNotification
